// Fecha ISO 8601 con el desfase del equipo (p. ej. 2026-10-05T14:03:11-04:00).
// No toISOString(): daría UTC con «Z» y el registro local quedaría en otra hora.
export function fechaIsoConOffset(fecha = new Date()) {
  const p = (n) => String(Math.abs(n)).padStart(2, '0');
  const offsetMin = -fecha.getTimezoneOffset();
  const signo = offsetMin >= 0 ? '+' : '-';
  return `${fecha.getFullYear()}-${p(fecha.getMonth() + 1)}-${p(fecha.getDate())}T${p(fecha.getHours())}:${p(fecha.getMinutes())}:${p(fecha.getSeconds())}`
    + `${signo}${p(Math.trunc(offsetMin / 60))}:${p(offsetMin % 60)}`;
}
